export const formatDate = (dateString: string | null): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString();
};

export const formatAmount = (amount: number, currency: string = 'USD'): string => {
  const abs = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';
  if (abs >= 1_000_000) {
    return `${sign}$${(abs / 1_000_000).toFixed(2)} M`;
  }
  if (abs >= 1_000) {
    const k = abs / 1_000;
    return `${sign}$${k % 1 === 0 ? k.toFixed(0) : parseFloat(k.toFixed(2))}K`;
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
};

export const formatAmountCompact = (amount: number): string => {
  const abs = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';
  if (abs >= 1_000_000) {
    return `${sign}$${(abs / 1_000_000).toFixed(2)}M`;
  }
  if (abs >= 1_000) {
    const k = abs / 1_000;
    return `${sign}$${k % 1 === 0 ? k.toFixed(0) : parseFloat(k.toFixed(2))}K`;
  }
  return `${sign}$${abs}`;
};

export const formatStatusDisplay = (status: string | undefined | null): string => {
  if (!status) return '-';
  return status.replace('_', ' ');
};

export const getStatusBadgeVariant = (status: string | undefined | null) => {
  if (!status) return "default";

  const variants = {
    paid: "default",
    unpaid: "destructive",
    partially_paid: "secondary",
    void: "outline",
  } as const;

  return variants[status as keyof typeof variants] || "default";
};

export const getSourceTypeBadgeColor = (sourceType: string | undefined | null): string => {
  if (!sourceType) return "bg-gray-100 text-gray-800";

  const colors = {
    expense: "bg-blue-100 text-blue-800",
    bill: "bg-orange-100 text-orange-800",
    payment: "bg-green-100 text-green-800"
  } as const;

  return colors[sourceType as keyof typeof colors] || "bg-gray-100 text-gray-800";
};